import { useCallback, useState } from 'react';

export function useSessionStorageState<T>(
  key: string,
  defaultValue: T,
  parse: (raw: unknown) => T | undefined,
): [T, (value: T) => void] {
  const [value, setValue] = useState<T>(() => {
    try {
      const raw = window.sessionStorage.getItem(key);
      if (raw === null) return defaultValue;
      return parse(JSON.parse(raw)) ?? defaultValue;
    } catch {
      return defaultValue;
    }
  });

  const persist = useCallback(
    (next: T) => {
      setValue(next);
      try {
        window.sessionStorage.setItem(key, JSON.stringify(next));
      } catch {
        // Storage is unavailable — keep the in-memory value and move on.
      }
    },
    [key],
  );

  return [value, persist];
}
